import { addMonths, format, subMonths, parse } from "date-fns";
import { useCallback, useEffect, useState } from "react";
import {
  useCalendarList,
  useCalendarPetList,
  // useCalendarProductCount,
  // useCalendarScheduleList,
} from "~/services/customer/calendar";

export interface CalendarPetListType {
  petSeq: number;
  petName: string;
  petAge: string;
  petBreed: string;
  petWeight: number;
  fileUrl: string;
  linkedYn?: string;
  linkedOwnerName?: string | null;
  linkedOwnerImageUrl?: string | null;
}

const useCalendar = () => {
  const [selectedPetSeq, setSelectedPetSeq] = useState<string>();
  const [selectDate, setSelectDate] = useState<string>(
    format(new Date(), "yyyyMMdd")
  );
  const [selectedDay, setSelectedDay] = useState<Date | null>(null);

  const {
    data: calendarPetList,
    isLoading: calendarPetListLoading,
    isFetching: calendarPetListFetching,
  } = useCalendarPetList();
  const {
    data: calendarList,
    isLoading: calendarListLoading,
    isFetching: calendarListFetching,
  } = useCalendarList({
    petSeq: selectedPetSeq || "",
    yearMonthDay: selectDate || "",
  });

  // const {
  //   data: calendarScheduleList,
  //   isLoading: calendarScheduleListLoading,
  //   isFetching: calendarScheduleListFetching,
  // } = useCalendarScheduleList({
  //   petSeq: selectedPetSeq || "",
  //   yearMonth: selectedDay ? format(selectedDay, "yyyyMMdd") : "",
  // });

  const petList = calendarPetList?.map((item: CalendarPetListType) => {
    return {
      seq: item.petSeq,
      title: item.petName,
      description: item.petBreed + " | " + item.petWeight + "kg",
      description1: item.petAge,
      image: item.fileUrl || "",
      linked: item.linkedYn === "Y",
      linkedOwnerName: item.linkedOwnerName,
      linkedOwnerImageUrl: item.linkedOwnerImageUrl,
    };
  });

  useEffect(() => {
    if (!calendarPetListLoading) {
      handleSelectPet(petList?.[0]?.seq.toString());
    }
  }, [calendarPetListLoading]);

  const handleSelectDate = useCallback((isNext: boolean) => {
    setSelectDate((prevDate) => {
      const currentDate = parse(prevDate, "yyyyMMdd", new Date());
      const newDate = isNext
        ? addMonths(currentDate, 1)
        : subMonths(currentDate, 1);
      // 항상 1일로 설정
      const firstDayOfMonth = new Date(
        newDate.getFullYear(),
        newDate.getMonth(),
        1
      );
      const formattedDate = format(firstDayOfMonth, "yyyyMMdd");

      // selectedDay도 함께 설정
      setSelectedDay(firstDayOfMonth);

      return formattedDate;
    });
  }, []);

  const handleSelectPet = (petSeq: string) => {
    setSelectedPetSeq(petSeq);
  };

  const handleSelectDay = (day: Date | null) => {
    setSelectedDay(day);
    if (day) {
      setSelectDate(format(day, "yyyyMMdd"));
    }
  };

  return {
    petList,
    selectedPetSeq,
    setSelectedPetSeq,
    calendarList,
    // calendarProductCount,
    handleSelectDate,
    handleSelectPet,
    selectDate,
    handleSelectDay,
    selectedDay,
    // calendarScheduleList,
    isLoading:
      calendarPetListLoading ||
      calendarListLoading,
      // ||
      // calendarProductCountLoading ||
      // calendarScheduleListLoading,
    isFetching:
      calendarPetListFetching ||
      calendarListFetching,
      // calendarProductCountFetching ||
      // calendarScheduleListFetching,
  };
};

export default useCalendar;
